import {
  Vehicle_TypeEnum,
  FeatureCollection_TypeEnum,
  Vehicle_PropulsionEnum,
  GraphCompareWithTotalResponse,
  GraphBucket,
  GraphBucketResponse,
  GraphBucketWithTotalResponse,
  GraphData,
  GraphStackResponse,
  GraphCompareResponse,
  GraphFilters_TripPurposeEnum,
  GraphFilters_LocationTypeEnum,
  GraphStackWithAverageResponse,
  Stops_LineTypeEnum,
} from 'src/api/gen/api'

import { ITemporalRange } from './temporalHelpers'

export interface IJson {
  [index: string]: any
}

export interface IOriginDestinationSankey {
  links: ILink[]
  nodes: INode[]
}

export interface IGenericBucket {
  doc_count?: number
  doc_count_without_percentage?: number
  key?: string
}

export interface IGraphComponent {
  filters: IFilters
  id?: string
  legend?: string
  title?: string
}

export enum GranularityEnum {
  day = 'day',
  hour = 'hour',
  month = 'month',
  quarter = 'quarter',
  week = 'week',
}

export interface IFilters {
  closeMeansOfTransport?: Stops_LineTypeEnum[]
  day_of_week?: string[]
  distance?: [number, number]
  // in seconds
  duration?: [number, number]
  endRange?: ITemporalRange
  granularity: GranularityEnum
  include_abnormals?: boolean
  layer?: string
  limit?: number
  locationTypes?: GraphFilters_LocationTypeEnum[]
  propulsions?: Vehicle_PropulsionEnum[]
  providers: string[]
  range: ITemporalRange
  // in meters/second
  speed?: [number, number]
  trip_purpose?: GraphFilters_TripPurposeEnum[]
  vehicleTypes?: Vehicle_TypeEnum[]
  zones?: string[]
}

export interface IFeature {
  properties: { label: string; percentage: number; value: number }
}

export interface IFeatureCollection {
  features: IFeature[]
  type: FeatureCollection_TypeEnum
}

export interface INode {
  key: string
  name: string
}

export interface IColoredNode extends INode {
  color: string
}

export interface ILink {
  source: number
  target: number
  value: number
}

export interface IColoredLink extends ILink {
  color: string
}

export type JurisdictionBoundary = GeoJSON.FeatureCollection<GeoJSON.MultiPolygon>

export interface IGraphCompareWithTotal {
  enableAnimation?: boolean
  granularity: GranularityEnum
  graphReport: GraphCompareWithTotalResponse
  graphReportPreviousYear?: GraphCompareWithTotalResponse
  title?: string
}

export interface IGraphStackWithAverage {
  enableAnimation?: boolean
  granularity: GranularityEnum
  graphReport: GraphStackWithAverageResponse
  title?: string
}

export interface IGraphBucketResponse {
  enableAnimation?: boolean
  granularity: GranularityEnum
  graphReport: GraphBucketResponse[]
  title?: string
}

export interface IGraphBucketList {
  enableAnimation?: boolean
  granularity: GranularityEnum
  graphReport: GraphBucket[]
  title?: string
}

export interface IGraphBucketWithTotal {
  enableAnimation?: boolean
  granularity: GranularityEnum
  graphReport: GraphBucketWithTotalResponse
  title?: string
}

export interface IGraphBucketWithTotalWithPreviousYear {
  enableAnimation?: boolean
  granularity: GranularityEnum
  graphReport: GraphBucketWithTotalResponse
  graphReportPreviousYear: GraphBucketWithTotalResponse
  title?: string
}

export interface IGraphData {
  enableAnimation?: boolean
  granularity: GranularityEnum
  graphReport: GraphData
  title?: string
}

export interface IGraphStack {
  enableAnimation?: boolean
  granularity: GranularityEnum
  graphReport: GraphStackResponse[]
  title?: string
}

export interface IGraphStackWithPreviousYear extends IGraphStack {
  graphReportPreviousYear: GraphStackResponse[]
}

export interface IGraphCompare {
  enableAnimation?: boolean
  granularity: GranularityEnum
  graphReport: GraphCompareResponse[]
  title?: string
}
